module.exports = __webpack_public_path__ + "img/landscaper.c8045e76.jpg";